import { render, staticRenderFns } from "./FailedBooking.vue?vue&type=template&id=05b293d3&scoped=true"
import script from "./FailedBooking.vue?vue&type=script&lang=js"
export * from "./FailedBooking.vue?vue&type=script&lang=js"
import style0 from "./FailedBooking.vue?vue&type=style&index=0&id=05b293d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b293d3",
  null
  
)

export default component.exports